import { useMemo } from 'react';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import { usePsfShareAvailableShareActions } from 'src/app/pages/psf/share/shared/hooks';

import { mapButtonConfigs, type ShareActionItem } from './mapButtonConfigs';
import type { ShareChannel } from './types';

export type { ShareChannel };

type UseActionItemsResult = ModelHookResult<{
	first: ShareActionItem | undefined;
	rest: readonly ShareActionItem[];
	shareVisualUrl: string | undefined;
}>;

export function useShareActions(): UseActionItemsResult {
	const pageData = usePsfSharePageData();
	const { bestShareVisual } = pageData.data.petition;
	const { psfShareAssetsExperimentVariation } = pageData.data;

	const availableShareActions = usePsfShareAvailableShareActions();
	const buttonConfigs = useMemo(() => mapButtonConfigs(availableShareActions), [availableShareActions]);

	const shareVisualUrl =
		psfShareAssetsExperimentVariation === 'variant_1' && bestShareVisual?.url ? bestShareVisual.url : undefined;

	if (buttonConfigs.length === 0) {
		return { data: { first: undefined, rest: [], shareVisualUrl } };
	}

	const [firstItem, ...restItems] = buttonConfigs;

	if (firstItem.channel !== 'copy') {
		return { data: { first: undefined, rest: buttonConfigs, shareVisualUrl } };
	}

	return { data: { first: firstItem, rest: restItems, shareVisualUrl } };
}
